import React, { useMemo, useState } from 'react';
import { Search, Phone, MapPin, Star, Car } from 'lucide-react';
import { PageHeader } from '../components/common/PageHeader';
import { StatusBadge } from '../components/common/StatusBadge';
import { FleetMap } from '../components/map/FleetMap';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/ui/Table';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/Select';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../components/ui/Dialog';
import { useFleet } from '../contexts/FleetContext';
import { formatTmt } from '../utils/format';
import { DriverStatus } from '../types/fleet';
export function Drivers() {
  const {
    drivers
  } = useFleet();
  const [query, setQuery] = useState('');
  const [status, setStatus] = useState<'all' | DriverStatus>('all');
  const [focused, setFocused] = useState<string | null>(null);
  const [detailsId, setDetailsId] = useState<string | null>(null);
  const filtered = useMemo(() => drivers.filter(d => (status === 'all' || d.status === status) && (d.name.toLowerCase().includes(query.toLowerCase()) || d.car.toLowerCase().includes(query.toLowerCase()) || d.plate.toLowerCase().includes(query.toLowerCase()))), [drivers, query, status]);
  const details = drivers.find(d => d.id === detailsId) ?? null;
  return <div data-id="element-289" data-mp="2eddvlbhlybcv">
      <PageHeader title="Водители" description={`Всего в автопарке: ${drivers.length} · На линии: ${drivers.filter(d => d.status !== 'offline').length}`} actions={<Button size="sm" data-id="element-291" data-mp="24jormncqg51p">Добавить водителя</Button>} data-id="element-290" data-mp="29gnj0y50hxw7" />

      <div className="grid grid-cols-1 gap-4 xl:grid-cols-3" data-id="element-292" data-mp="1zjsjqd0wztgv">
        <Card className="xl:col-span-2" data-id="element-293" data-mp="1pv52wv06fdlf">
          <CardHeader className="gap-3 pb-3" data-id="element-294" data-mp="1pu3ukyajp57e">
            <CardTitle className="text-base" data-id="element-295" data-mp="1utykozmhxqre">Список водителей</CardTitle>
            <div className="flex flex-wrap items-center gap-2" data-id="element-296" data-mp="1uv9k6n8wsccp">
              <div className="relative min-w-[220px] flex-1" data-id="element-297" data-mp="1gv8l9dc7fezv">
                <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" aria-hidden="true" data-id="element-298" data-mp="1kvsfa81he2hs" />
                <Input value={query} onChange={e => setQuery(e.target.value)} placeholder="Поиск по имени, авто или номеру" aria-label="Поиск водителя" className="h-9 pl-9" data-id="element-299" data-mp="28mo9fbtet9s7" />
              </div>
              <Select value={status} onValueChange={v => setStatus(v as 'all' | DriverStatus)} data-id="element-300" data-mp="23t3gvzal580e">
                <SelectTrigger className="w-[170px]" data-id="element-301" data-mp="2rio1snqaufcb">
                  <SelectValue placeholder="Статус" data-id="element-302" data-mp="2wapc443wpvzp" />
                </SelectTrigger>
                <SelectContent data-id="element-303" data-mp="kvyt4zj014l6">
                  <SelectItem value="all" data-id="element-304" data-mp="kv6vlj5ucws9">Все статусы</SelectItem>
                  <SelectItem value="free" data-id="element-305" data-mp="fwvkl53t8g8g">Свободен</SelectItem>
                  <SelectItem value="busy" data-id="element-306" data-mp="fwccsh7vj885">В поездке</SelectItem>
                  <SelectItem value="offline" data-id="element-307" data-mp="um1kywedwchx">Офлайн</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </CardHeader>
          <CardContent className="p-0" data-id="element-308" data-mp="pp1cyfxz4zo6">
            <div className="overflow-x-auto" data-id="element-309" data-mp="1wb4igpa4yin">
              <Table data-id="element-310" data-mp="1z71a1pe5h5i">
                <TableHeader data-id="element-311" data-mp="3t3fad89oueph">
                  <TableRow data-id="element-312" data-mp="3t470w4ofhm8w">
                    <TableHead data-id="element-313" data-mp="3t58g8lch8uwf">Имя</TableHead>
                    <TableHead data-id="element-314" data-mp="bv0p4h8k8x2l">Статус</TableHead>
                    <TableHead data-id="element-315" data-mp="bwv7powd0d3i">Автомобиль</TableHead>
                    <TableHead data-id="element-316" data-mp="6vo13t5ydjyf">Местоположение</TableHead>
                    <TableHead className="text-right" data-id="element-317" data-mp="6uw6olo3ds9q">Поездки / Заработок</TableHead>
                    <TableHead data-id="element-318" data-mp="1n8w2bkfwmvr6">Телефон</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody data-id="element-319" data-mp="1ib2wwtmfe5ry">
                  {filtered.map(driver => <TableRow key={driver.id} onClick={() => {
                  setFocused(driver.id);
                  setDetailsId(driver.id);
                }} className="cursor-pointer" data-id="element-320" data-mp="3o0y75najyn1m">
                      <TableCell className="font-medium text-foreground" data-id="element-321" data-mp="5uta8mfcp9ws">
                        <span className="flex items-center gap-1.5" data-id="element-322" data-mp="atmq2li41d04">
                          {driver.name}
                          <span className="inline-flex items-center gap-0.5 text-xs text-muted-foreground" data-id="element-323" data-mp="frefn8va8n15">
                            <Star className="h-3 w-3 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-324" data-mp="kjz8a72gcu33" />
                            {driver.rating.toFixed(1)}
                          </span>
                        </span>
                      </TableCell>
                      <TableCell data-id="element-325" data-mp="yip4lkhg6pqe">
                        <StatusBadge status={driver.status} data-id="element-326" data-mp="yhw3az19csfn" />
                      </TableCell>
                      <TableCell className="text-muted-foreground" data-id="element-327" data-mp="18mw2ndk1d5zl">
                        {driver.car}
                        <span className="block text-xs" data-id="element-328" data-mp="13mht1r2sdnzg">{driver.plate}</span>
                      </TableCell>
                      <TableCell className="text-muted-foreground" data-id="element-329" data-mp="yp7vfo58u60j">{driver.location}</TableCell>
                      <TableCell className="text-right" data-id="element-330" data-mp="uo66q18ydcct">
                        <span className="font-medium text-foreground" data-id="element-331" data-mp="1rd3yrbpbiw6a">{driver.tripsToday}</span>
                        <span className="block text-xs text-muted-foreground" data-id="element-332" data-mp="1me0tbq5fenxs">{formatTmt(driver.earningsToday)}</span>
                      </TableCell>
                      <TableCell className="whitespace-nowrap text-muted-foreground" data-id="element-333" data-mp="1hlzkke7gvfci">{driver.phone}</TableCell>
                    </TableRow>)}
                  {filtered.length === 0 && <TableRow data-id="element-334" data-mp="2a56duimba4ef">
                      <TableCell colSpan={6} className="py-10 text-center text-sm text-muted-foreground" data-id="element-335" data-mp="25cwph70uhce9">
                        Водители не найдены. Измените параметры поиска.
                      </TableCell>
                    </TableRow>}
                </TableBody>
              </Table>
            </div>
          </CardContent>
        </Card>

        <Card className="overflow-hidden" data-id="element-336" data-mp="3pue6yd28n34o">
          <CardHeader className="pb-3" data-id="element-337" data-mp="3utqvd28rci9d">
            <CardTitle className="text-base" data-id="element-338" data-mp="3uspiqtc3fnpj">Положение на карте</CardTitle>
          </CardHeader>
          <CardContent className="p-3 pt-0" data-id="element-339" data-mp="3gtg2jtnw0tlk">
            <div className="h-[320px] sm:h-[420px]" data-id="element-340" data-mp="3gwlpp3cyhlen">
              <FleetMap drivers={filtered} selectedId={focused} onSelect={setFocused} data-id="element-341" data-mp="3lu3t6e87f8f9" />
            </div>
          </CardContent>
        </Card>
      </div>

      <Dialog open={!!details} onOpenChange={open => !open && setDetailsId(null)} data-id="element-342" data-mp="3bv63v92yfav7">
        <DialogContent data-id="element-343" data-mp="3bwzeezgouf8h">
          {details && <>
              <DialogHeader data-id="element-344" data-mp="15580oq5aotdc">
                <DialogTitle data-id="element-345" data-mp="152vo6sib3b7o">{details.name}</DialogTitle>
                <DialogDescription data-id="element-346" data-mp="1a2i1f1y4wrgh">Карточка водителя · рейтинг {details.rating.toFixed(1)}</DialogDescription>
              </DialogHeader>
              <div className="space-y-3 py-2" data-id="element-347" data-mp="2ujhego2poxnw">
                <div className="flex items-center justify-between" data-id="element-348" data-mp="2pnscke37z4of">
                  <span className="text-sm text-muted-foreground" data-id="element-349" data-mp="34bdei4ocyxur">Статус</span>
                  <StatusBadge status={details.status} data-id="element-350" data-mp="34dgenhj867d7" />
                </div>
                <div className="flex items-start justify-between gap-4" data-id="element-351" data-mp="2zjlxolv086ht">
                  <span className="flex items-center gap-1.5 text-sm text-muted-foreground" data-id="element-352" data-mp="3dba9sp596uys">
                    <Car className="h-4 w-4" aria-hidden="true" data-id="element-353" data-mp="399onyeaqr6cg" /> Автомобиль
                  </span>
                  <span className="text-right text-sm text-foreground" data-id="element-354" data-mp="3n9g8kxvrjkzf">
                    {details.car}
                    <span className="block text-xs text-muted-foreground" data-id="element-355" data-mp="3icpugg3iqzgn">{details.plate}</span>
                  </span>
                </div>
                <div className="flex items-start justify-between gap-4" data-id="element-356" data-mp="1syb985rplupw">
                  <span className="flex items-center gap-1.5 text-sm text-muted-foreground" data-id="element-357" data-mp="1nyyd0uey7ban">
                    <MapPin className="h-4 w-4" aria-hidden="true" data-id="element-358" data-mp="123olzu748678" /> Местоположение
                  </span>
                  <span className="text-right text-sm text-foreground" data-id="element-359" data-mp="171hrsm4iay6z">{details.location}</span>
                </div>
                <div className="flex items-center justify-between" data-id="element-360" data-mp="1bw420lyuqkph">
                  <span className="flex items-center gap-1.5 text-sm text-muted-foreground" data-id="element-361" data-mp="1grsyuhjhlni3">
                    <Phone className="h-4 w-4" aria-hidden="true" data-id="element-362" data-mp="j6nea1m6frzl" /> Телефон
                  </span>
                  <span className="text-sm text-foreground" data-id="element-363" data-mp="o586pev6t7dh">{details.phone}</span>
                </div>
                <div className="grid grid-cols-2 gap-3 pt-1" data-id="element-364" data-mp="t2qcwxhtl8hs">
                  <div className="rounded-lg border border-border bg-muted/40 p-3" data-id="element-365" data-mp="y35s7ulnwq2e">
                    <p className="text-xs text-muted-foreground" data-id="element-366" data-mp="24ioslk7i6srz">Поездок сегодня</p>
                    <p className="mt-0.5 text-lg font-semibold text-foreground" data-id="element-367" data-mp="24l18zsxm4v2x">{details.tripsToday}</p>
                  </div>
                  <div className="rounded-lg border border-border bg-muted/40 p-3" data-id="element-368" data-mp="3u0c061zipxyd">
                    <p className="text-xs text-muted-foreground" data-id="element-369" data-mp="3p0r35x3wrzoa">Заработок сегодня</p>
                    <p className="mt-0.5 text-lg font-semibold text-foreground" data-id="element-370" data-mp="3p33gfwyq1lv0">{formatTmt(details.earningsToday)}</p>
                  </div>
                </div>
              </div>
              <DialogFooter data-id="element-371" data-mp="3fanz91v911b6">
                <Button variant="outline" onClick={() => setDetailsId(null)} data-id="element-372" data-mp="3aburlq2n84ix">
                  Закрыть
                </Button>
                <Button onClick={() => setDetailsId(null)} data-id="element-373" data-mp="369zruq0d1z79">Показать на карте</Button>
              </DialogFooter>
            </>}
        </DialogContent>
      </Dialog>
    </div>;
}